import Heading from 'components/atoms/Heading/Heading';
import Card, { Props as CardProps } from '../../atoms/Card/Card';
import classes from './RewardsLinkCard.module.scss';
import React, { FC, SVGProps } from 'react';
import Txt from 'components/atoms/Txt/Txt';
import A from 'components/atoms/A/A';

export type Props = {
  icon: FC<SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
  className?: string;
  href: string;
};

export default function RewardsLinkCard({ icon, title, description, href, className }: Props) {
  const Icon = icon;

  return (
    <A href={href} className={classes.root}>
      <Card className={classes.card}>
        <div className={classes.content}>
          <div className={classes.iconContainer}>
            <Icon className={classes.icon} />
          </div>
          <div className={classes.info}>
            <Heading level={5} className={classes.heading}>
              {title}
            </Heading>
            <Txt component="p" className={classes.description}>
              {description}
            </Txt>
          </div>
        </div>
      </Card>
    </A>
  );
}
